<template>
  <div class="background">
    <a-tabs v-model="routeNow" @change="routeChange">
      <a-tab-pane key="/meeting/list" tab="已排会"> </a-tab-pane>
      <a-tab-pane v-if="hasSuggestPermission" key="/meeting/createMeeting" :tab="'待排会(' + sumNum + ')'"> </a-tab-pane>
      <!-- <router-link to="/meeting/list"><a-button type="primary">toList</a-button></router-link> -->
      <!-- <router-link to="/meeting/list"><a-button type="primary">path</a-button></router-link> -->
    </a-tabs>
    <router-view @updateNum="updateNum" @updateTab="updateTab"> </router-view>
  </div>
</template>
<style lang="less" scoped>
.background {
  background-color: white;
  padding: 12px 28px 16px 28px;
  // width: 100vw;
}
</style>
<script>
import { getMeetingProjectNum } from '@/api/meeting.js';
import { audioMeetingDetail } from '@/api/project';
import moment from 'moment';
import debounce from 'lodash/debounce';
import { hasPermission } from '@/utils/utils';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      sumNum: 0,
      routeNow: '/meeting/list',
      hasSuggestPermission: false
    };
  },
  computed: { ...mapGetters(['userInfo'])},
  watch: {
    $route: {
      handler: function(route) {
        // console.log('routehandler',route);
        this.routeNow = route.path;
      },
      immediate: true
    }
  },

  methods: {
    updateTab() {
      this.routeNow = this.$route.path;
    },
    routeChange(key) {
      this.$router.push(key);
    },
    updateNum(num) {
      // this.sumNum = num;
      this.getNum();
    },
    async getNum() {
      let res = await getMeetingProjectNum({ status: 0 });
      if (res.code === 200) {
        this.sumNum = res.data;
      }
    }
  },

  created() {
    this.getNum();
    const { permissions:queue } = this.userInfo || {};
    this.hasSuggestPermission = hasPermission(queue, '/meeting/createMeeting');
  },

  mounted() {}
};
</script>
